export default class AuthService {
  /* @ngInject */
  constructor(LocalStorageService, AUTH_CONSTANT, FENDI_CONSTANT) {
    this.localStorageService = LocalStorageService;
    this.AUTH_CONSTANT = AUTH_CONSTANT;
    this.FENDI_CONSTANT = FENDI_CONSTANT;
  }

  createAuthorization(jwt = this.token()) {
    return `Bearer ${jwt}`;
  }

  token(jwt) {
    if (jwt) {
      this.localStorageService.set(this.TOKEN, jwt);
    } else if (jwt === null) {
      this.hasErrorCompany = false;
      this.localStorageService.remove(this.TOKEN);
    } else {
      return this.localStorageService.get(this.TOKEN);
    }
  }

  payload(section, token = this.token()) {
    return token && section ? this._splitter(1, token)[section] : token ? this._splitter(1, token) : null;
  }

  username() {
    return this.payload('upn');
  }

  name() {
    return this.payload('given_name');
  }

  surname() {
    return this.payload('family_name');
  }

  roles() {
    const roles = this.payload('role_filtered');
    if (!roles) {
      alert('Access to app not allowed');
      return [];
    }

    if (typeof roles == 'string') {
      return [roles];
    }
    return roles;
  }

  isPersonalShopper() {
    return this.roles()
      .find(role => role === this.AUTH_CONSTANT.ROLE_PERSONAL_SHOPPER);
  }

  isStore() {
    return this.roles()
      .find(role => role === this.AUTH_CONSTANT.ROLE_STORE);
  }

  isOffice() {
    return this.roles()
      .find(role => role === this.AUTH_CONSTANT.ROLE_OFFICE);
  }

  isFendiInternetUser() {
    return this.roles()
      .find(role => role === this.AUTH_CONSTANT.ROLE_FENDI_INTERNET_USER);
  }

  hasKnownRole() {
    const {ROLE_PERSONAL_SHOPPER, ROLE_STORE, ROLE_OFFICE} = this.AUTH_CONSTANT;
    const roles = this.roles();
    return !!roles.find(role => role === ROLE_PERSONAL_SHOPPER || role === ROLE_STORE || role === ROLE_OFFICE);
  }

  canAccessFromExternalInternet() {
    return !!this.isFendiInternetUser();
    // return !!(this.isFendiInternetUser() || this.isPersonalShopper());
  }

  isAccessingFromExternalInternet() {
    return !!(this.FENDI_CONSTANT.userLocation == 'EXTERNAL');
  }

  currentStoreId(token) {
    return this.payload('bs_extensionAttribute1', token);
  }

  company() {
    try {
      return this.payload('Company');
    } catch (e) {
      if (!this.hasErrorCompany) {
        alert('User misconfiguration error\n\nMissing field: Company');
      }
      this.hasErrorCompany = true;
      throw new Error('Unknown Company in JWT');
    }
  }

  createdBy(marketId) {
    return {
      createdBy: {
        firstName: this.name(),
        lastName: this.surname(),
        email: this.username(),
        id: this.username(),
      },
      marketId,
      storeId: this.currentStoreId(),
    };
  }

  _splitter(section, explicitToken) {
    const token = explicitToken || this.token();
    return JSON.parse(atob(token.split('.')[section]));
  }

  get TOKEN() {
    return 'jwt';
  }
}



// WEBPACK FOOTER //
// ./src/app/core/auth/auth.service.js